export default __webpack_public_path__ + "static/media/red_bookmark.b47ff519.png";